
  import {prepareImageUrl} from '@/helper/ImageHelper';

  export default {
    components: {
      RichText: () => import('@/components/elements/RichText'),
    },
    props: {
      content: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        imageUrl: '',
      };
    },
    created() {
      if (this.content.image) {
        this.imageUrl = prepareImageUrl(this.content.image.url);
      }
    },
  };
